/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

;// ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// ./src/js/helpers/get-window.js
/* harmony default export */ var get_window = (() => {
  if (typeof window !== 'undefined') {
    return window;
  }
  return false;
});
;// ./src/js/helpers/logger.js
/* eslint-disable no-underscore-dangle */

const win = get_window();

/**
 * Types are error, warn, info and log
 * Message can be a String, Array or Object
 */
/* harmony default export */ var logger = ((type, message, code) => {
  if (win._satellite && win._satellite.logger) {
    win.document.dispatchEvent(new CustomEvent('onAdobeOmniLoggerReady'));
    win._satellite.logger[type](message, typeof code === 'undefined' ? '' : code);
  } else {
    const callBack = () => win._satellite.logger[type](message, typeof code === 'undefined' ? '' : code);
    if (win.loggerWaitingList) {
      win.loggerWaitingList.push({
        callBack
      });
    } else {
      win.loggerWaitingList = [];
      win.loggerWaitingList.push({
        callBack
      });
    }
    win.document.addEventListener('onAdobeOmniLoggerReady', () => {
      if (win.loggerWaitingList) {
        while (win.loggerWaitingList.length > 0) {
          const func = win.loggerWaitingList.shift();
          func.callBack(func.settings, func.options);
        }
      }
    });
  }
});
;// ./src/js/directives/directive.js
/**
 * Metric Directive
 */


const directive_win = get_window();
const setNewDataAttr = (key, value, el) => {
  if (key && !el.attributes[`data-metrics-${key}`]) {
    el.setAttribute(`data-metrics-${key}`, value);
  }
};

// extracts data-metrics atrributes in key-value pairs
const getDataMetricsAttributes = node => {
  const keyvalues = {};
  Object.entries(node.dataset).map(items => {
    if (items[0].indexOf('metrics') > -1) {
      const key = items[0].replace('metrics', '').toLowerCase();
      // eslint-disable-next-line prefer-destructuring
      keyvalues[key] = items[1];
    }
    return true;
  });
  return Object.entries(keyvalues);
};

/*
 * Creating this function for two reasons:
 * - element.closest function is not supported in IE
 * - element.closest does not include current element, which is supported in the old jQuery usage
 */
const findClosest = (el, selector) => {
  let matchesFn;
  let parent;
  let ele = el;

  // find vendor prefix
  ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].some(fn => {
    if (typeof document.body[fn] === 'function') {
      matchesFn = fn;
      return true;
    }
    return false;
  });

  // Check the current element first
  if (ele && ele[matchesFn](selector)) {
    return ele;
  }

  // then traverse parents
  while (ele) {
    parent = ele.parentElement;
    if (parent && parent[matchesFn](selector)) {
      return parent;
    }
    ele = parent;
  }
  return null;
};

/**
 * crawls the dom and reads data values to return the metrics value of an element
 * @see bindDataMetricsModule
 * @param  {Object} el "a" or "button" element
 * @return {String} the metrics value of element
 */
const getDataMetricsValue = el => {
  let metricsValue;
  let linkMetricsValue = '';
  let elementSelector;
  let moduleToLinkSeperator = '_';
  let sectionToLinkSeperator = '-';
  let allElementsFoundBySelector;
  let sectionValue = '';
  let contextElement;
  let hasMetricsSection = false;

  // we're going to do stuff in order to make this code as efficient as possible
  const moduleElement = findClosest(el, '*[data-metrics-module]');

  // if we don't find a module metrics call, go ahead and get out, we don't need to do anything
  if (!moduleElement) {
    return false;
  }

  // we are to get the metrics-section value
  const metricsSection = findClosest(el, '*[data-metrics-section]');
  if (metricsSection) {
    sectionValue = metricsSection.getAttribute('data-metrics-section');
    if (sectionValue !== '') {
      hasMetricsSection = true;
    }
  }

  // we can defintely grab this as we've verified that by now, there is this data attribute
  const moduleMetricsValue = moduleElement.getAttribute('data-metrics-module');

  /*
   * now we try to grab the link value override. If this exists,
   * we'll use it, no need to crawl looking for dynamic naming
   */
  const link = findClosest(el, '*[data-metrics-link]');

  // if we have one of these, use it for the link metrics value, otherwise, do it dynamically
  if (link) {
    linkMetricsValue = link.getAttribute('data-metrics-link');
  } else {
    // grab the element selector if it exists

    // we need to determine the context element first: which can either be a module or section
    contextElement = hasMetricsSection ? metricsSection : moduleElement;
    elementSelector = contextElement.getAttribute('data-metrics-sel');

    // if so, let's use it
    if (elementSelector) {
      // grab all the elements found by selector
      allElementsFoundBySelector = contextElement.querySelectorAll(elementSelector);
      let index = 1;

      /*
       * in this set of elements, find the one we clicked on,
       * this is our metrics value. Add 1, since that's how .index works
       */
      // eslint-disable-next-line no-restricted-syntax
      for (const element of allElementsFoundBySelector) {
        if (element === el.parentNode) {
          linkMetricsValue = index;
        } else {
          // eslint-disable-next-line no-plusplus
          index++;
        }
      }
    }
  }
  if (hasMetricsSection) {
    // this 'if' will prevent orphaned '-' at the end...
    if (linkMetricsValue === '') {
      sectionToLinkSeperator = '';
    }
    metricsValue = moduleMetricsValue + moduleToLinkSeperator + sectionValue + sectionToLinkSeperator + linkMetricsValue;
  } else {
    /*
     * remove separator '_' when either metrics-module
     * or metrics-link is an empty string.
     * this provides flexibility of passing metrics values
     * that do not require a link ID or separator
     */
    if (moduleMetricsValue === '' || linkMetricsValue === '') {
      moduleToLinkSeperator = '';
    }
    metricsValue = moduleMetricsValue + moduleToLinkSeperator + linkMetricsValue;
  }
  return metricsValue;
};

/**
 * Global click handler for metrics (moduleID_linkID). No more onclicks.
 * We are catching any clicks on a elements and firing off some metrics
 *
 * This uses HTML5 data attributes to select HTML elements to create metrics
 *
 * - data-metrics-module: <required> This will be the module value.
 * It should be on the module containing div, as clicks on a elements will look
 * up in the DOM tree until they find a metrics-module value and use that.
 * There can be multiples of this on a module, and any link will
 * use the closest one to it as the module value. If this is left off the
 * parent module, there will be no metrics calls.
 *
 * - data-metrics-sel: <optional> This is the selector to get link ID's
 * and should be placed on the same node as metrics-module
 * (unless metrics-section is being used). Since most modules have simple
 * 1-X link id naming, this allows for us to not have to specify
 * this for every link. The code will use the metrics-module node and
 * .find this selector and grab the clicked on index to pass into the link value.
 * If this, as well as the metrics-link on a particular link is missing,
 * the code will pass a link id of 0
 *
 * - data-metrics-link: <optional> This is the override to metrics-sel.
 * If this data attribute exists on a link or one of it's parents,
 * it will be used for the link id. If this is missing, the code will
 * look for it on the closest parent. If it's not found,
 * metrics-sel to pick link id. If both are missing, 0 will be passed
 *
 * - data-metrics-section: <optional>.  If present, its value will be
 * placed in front of the metrics-link value with a dash as the separator between the 2.
 * This serves as an convenience attribute for the requirement that
 * divides multiple sections within a given metric-module.
 * If data-metrics-sel is used, it should be placed on the same element
 * as this data-metrics-section.
 * Sample usage can be found in the footer section of any harmony pages.
 *
 * - data-metrics-type: <optional> "track" or "ad-hoc". The default is "track",
 * which is a standard wmdTrack call when going to a new page or calling a
 * dynamic page view right after. If your a element is instead triggering some
 * sort of page action that doesn't result in a new
 * page view, you can specify "ad-hoc" and the code will make a wmdPageLink call instead.
 *
 */
const bindDataMetricsModule = (el, type) => {
  // linktext(el);
  const metricsValue = getDataMetricsValue(el);

  // if we don't find a module metrics value, go ahead and get out, we don't need to do anything
  if (!metricsValue) {
    return;
  }

  // let's see if we have a type override
  let metricType = findClosest(el, '*[data-metrics-type]');
  if (metricType) {
    metricType = metricType.getAttribute('data-metrics-type');
  } else {
    metricType = 'track';
  }

  // and we'll call track or link based on that possible override
  if (type === 'dpv') {
    directive_win.wmdDpv({
      pageName: el.getAttribute('data-metrics-pagename') || '',
      moduleName: metricsValue,
      iCount: el.getAttribute('data-metrics-icount') || '',
      s_sponUri: el.getAttribute('data-metrics-sponuri') || '',
      refresh: true
    });
  } else if (metricType === 'track') {
    directive_win.wmdTrack({
      moduleName: metricsValue
    });
  } else {
    const {
      href
    } = el;
    const regex = new RegExp('\\.(exe|zip|wav|mp3|mov|mpg|avi|wmv|pdf|doc|docx|xls|xlsx|ppt|pptx)$');
    let url = '';
    let lnkType = 'o';

    // Set lnkType if href exist
    if (href) {
      // If href matches current site set exit for link type
      if (regex.test(href)) {
        lnkType = 'd';
        url = href;
      }
      if (lnkType !== 'd') {
        try {
          url = new URL(href);
          url = url.hostname;

          // If href doesnt match current site set exit for link type
          if (url !== window.location.hostname) {
            lnkType = 'e';
          }
        } catch (error) {
          log('error', error);
        }
      }
    }
    directive_win.wmdPageLink({
      moduleName: metricsValue,
      url,
      linkType: lnkType
    });
  }
};

// use a event handler to avoid multiple calls;
// eslint-disable-next-line no-unused-vars
const bindDataMetricsModuleHandler = (event, type) => {
  bindDataMetricsModule(event.currentTarget, type);
};
const bindClickEvents = (el, binding) => {
  // Converting Object into Array so we can iterate over easily
  // eslint-disable-next-line max-len
  const keyValues = binding.value ? Object.entries(binding.value) : getDataMetricsAttributes(el);
  // eslint-disable-next-line no-empty

  // Check if we have values
  if (keyValues) {
    keyValues.map(item => {
      // Set the new data attributes on the current element
      setNewDataAttr(item[0], item[1], el);

      /*
       * Check if this item is a module, "children nodes" here includes the original element,
       * since we support module + link on the same element
       */
      if (item[0] === 'module' || el.attributes['data-metrics-module']) {
        const childrenNodes = el.getElementsByTagName('*');
        const childrenArr = [el, ...childrenNodes];
        childrenArr.map(child => {
          // Check if the child node is a button or anchor tag
          if (child.nodeName === 'BUTTON' || child.nodeName === 'A') {
            if (binding.arg !== 'dpv') {
              /*
               *  Set a click event on tags
               * child.addEventListener('click', bindDataMetricsModuleHandler);
               */
            }
          }
          return true;
        });
      }
      return true;
    });
  }

  // Adding Click Event to Tags that are not Buttons or A tags
  if (binding.arg === 'track') {
    // el.addEventListener('click', (e) => bindDataMetricsModuleHandler(e, 'custom'));
  }

  // Adding Click Event to Tags for Dynamic Pageviews
  if (binding.arg === 'dpv') {
    // el.addEventListener('click', (e) => bindDataMetricsModuleHandler(e, 'dpv'));
  }
};
const directive = {
  getSSRProps(binding) {
    // server-side implementation: return the props to be rendered.
    const metrics = {};
    if (typeof binding.value !== 'object') return metrics;
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const key in binding.value) {
      const newKey = `data-metrics-${key}`;
      metrics[newKey] = binding.value[key];
    }
    return metrics;
  },
  beforeMount(el, binding) {
    // Converting Object into Array so we can iterate over easily
    const keyValues = binding.value ? Object.entries(binding.value) : undefined;

    // if the developer want to fire the omniture manually set is disabled
    if (binding.arg === 'disable') {
      if (keyValues) {
        keyValues.map(item => {
          // Set the new data attributes on the current element
          setNewDataAttr(item[0], item[1], el);
          return true;
        });
      }
    } else {
      bindClickEvents(el, binding);
    }

    // vnode.context.app.config.globalProperties.$bindMetrics = bindClickEvents;
  },
  updated(el, binding) {
    bindClickEvents(el, binding);
  }
};
/* harmony default export */ var directives_directive = ({
  directive,
  bindClickEvents
});
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./src/Omniture.vue?vue&type=script&lang=js
/* harmony default export */ var Omniturevue_type_script_lang_js = ({
  functional: true,
  render: () => true
});
;// ./src/Omniture.vue?vue&type=script&lang=js
 
;// ./src/Omniture.vue



const __exports__ = Omniturevue_type_script_lang_js;

/* harmony default export */ var Omniture = (__exports__);
;// ./src/js/trackers/omniture-functions.js
/* eslint-disable no-underscore-dangle */

const omniture_functions_win = get_window();

/**
 * wmdPageview
 * @param {Object} settings key/values for sSource
 * @param {Object} options ...
 * This function takes specific settings that could
 * be passsed by other functions such as wmdDpv. We also allow
 * some options to be set if you wanted to modify the current
 * settings or global adobeDataLayer
 */
const wmdPageview = (settings, options) => {
  if (omniture_functions_win.wmdPageview) {
    omniture_functions_win.wmdPageview(settings, options);
  }
};

/**
 * wmdPageLink
 * @param {Object} settings key/values for sSource
 * @param {Object} options nothing used currently
 * This function takes the link ...
 */
const wmdPageLink = (settings, options) => {
  if (omniture_functions_win.wmdPageLink) {
    omniture_functions_win.wmdPageLink(settings, options);
  }
};

/**
 * wmdTrack
 * @param {Object} settings key/values for sSource
 * @param {Object} options nothing used currently
 * This function takes the sSource string value and sets it into ctr storage items.
 */
const wmdTrack = settings => {
  if (omniture_functions_win.wmdTrack) {
    omniture_functions_win.wmdTrack(settings);
  }
};
const wmdDpv = (settings, options) => {
  if (omniture_functions_win.wmdDpv) {
    omniture_functions_win.wmdDpv(settings, options);
  }
};
const wmdSearchTrack = (settings, options) => {
  if (omniture_functions_win.wmdSearchTrack) {
    omniture_functions_win.wmdSearchTrack(settings);
  }
};
const wmdSetUserSegment = (segment, persistence, program) => {
  if (omniture_functions_win.wmdSearchTrack) {
    omniture_functions_win.wmdSearchTrack(segment, persistence, program);
  }
};
const wmdClearMetrics = doPV => {
  if (omniture_functions_win.wmdClearMetrics) {
    omniture_functions_win.wmdClearMetrics(doPV);
  }
};
;// ./src/js/helpers/cookie-functions.js
/* eslint-disable no-underscore-dangle,max-len */

const cookie_functions_win = get_window();
const setCookie = (cName, cValue, expDays) => {
  let date = new Date();
  date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
};
const readCookie = key => {
  const name = key + "=";
  const cDecoded = decodeURIComponent(window.document.cookie); //to be careful
  const cArr = cDecoded.split('; ');
  let res = '';
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });
  return res;
};
const deleteCookie = key => {
  window.document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
};
;// ./src/js/helpers/data-metric-closest.js

const data_metric_closest_win = get_window();

// for the IE browser not going to support ie8 :D
const addClosestFunction = () => {
  if (data_metric_closest_win) {
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    }
    if (!Element.prototype.closest) {
      // eslint-disable-next-line func-names
      Element.prototype.closest = function (s) {
        let el = this;
        if (!document.documentElement.contains(el)) return null;
        do {
          if (el.matches(s)) return el;
          el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
      };
    }
  }
};

// eslint-disable-next-line no-unused-vars
/* harmony default export */ var data_metric_closest = ((selector, options, type) => {
  const moduleType = type === 'module' ? 'data-metrics-module' : 'data-metrics-link';
  addClosestFunction();
  const linkNode = selector.closest(`*[${moduleType}]`);
  return linkNode ? linkNode.getAttribute(moduleType) : 'unableToFindModuleValue';
});
;// ./src/js/index.js
/* eslint-disable no-param-reassign,max-len,consistent-return,no-underscore-dangle,camelcase */
// this is the main entry of omniture plugin







// export default Metric plugin;
const metricplugin = {
  install(app) {
    /* Omniture Component */
    app.component('Omniture', Omniture);

    /* Metric Directive */
    app.directive('metric', directives_directive.directive);
    app.config.globalProperties.$bindMetrics = directives_directive.bindClickEvents;
    /* WebMD Core Functions */
    app.config.globalProperties.$vwmdPageview = (settings, options) => wmdPageview(settings, options);
    app.config.globalProperties.$vwmdPageLink = (settings, options) => wmdPageLink(settings, options);
    app.config.globalProperties.$vwmdTrack = (settings, options) => wmdTrack(settings, options);
    app.config.globalProperties.$vwmdDpv = (settings, options) => wmdDpv(settings, options);
    app.config.globalProperties.$vwmdSearchTrack = (settings, options) => wmdSearchTrack(settings, options);
    app.config.globalProperties.$vwmdReset = doPV => wmdClearMetrics(doPV);

    /* Cookie Functions */
    app.config.globalProperties.$vsetCookie = (key, value) => setCookie(key, value);
    app.config.globalProperties.$vreadCookie = key => readCookie(key);
    app.config.globalProperties.$vdeleteCookie = key => deleteCookie(key);

    /* Data Metric Closest Funtions */
    app.config.globalProperties.$vgetClosestModule = (selector, options) => data_metric_closest(selector, options, 'module');
    app.config.globalProperties.$vgetClosestMlink = (selector, options) => data_metric_closest(selector, options, 'link');

    /* Legacy Funtions - Limited or No Support */
    app.config.globalProperties.$vwmddpv = (settings, options) => app.config.globalProperties.$vwmdDpv(settings, options);
    app.config.globalProperties.$vwmdSetContext = () => logger('error', 'NO MORE SUPPORT FOR vwmdSetContext method');
    app.config.globalProperties.$vsetSinglePropValue = () => logger('error', 'NO MORE SUPPORT FOR vsetSinglePropValue method');
  }
};
/* harmony default export */ var js = (metricplugin);
;// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (js);


module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=metric.common.js.map